<app-base-modal
  [title]="getTitleModal()"
  [showStateToggle]="isValid"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div class="content">
    @for (designBlock of designBlocksData; track $index) {
      <div
        class="row"
        app-base-design-block-form
        [designBlockData]="designBlock"
        [designBlockFormGroup]="designBlockFormGroups[$index]"
        [parentId]="baseDesignBlockDialogData.parentId"
        [isEditModeActive]="isEditModeActive"
        [columnKey]="baseDesignBlockDialogData.modalKey"
        [noFirstData]="noFirstData"
        (updateDesignBlock)="updateDesignBlockData($event, $index)"
        (deleteDesignBlock)="deleteDesignBlockData($index)"
      ></div>
    }
  </div>
  <div class="row-bottom">
    <button
      mat-mini-fab
      class="row-btn-add"
      [disabled]="!isValid"
      (click)="handleAddNew()"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>
</app-base-modal>
